var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEaGemeinschaft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 160 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#e6af78;}.cls-3{fill:#59667c;}.cls-4{fill:#d29b6e;}.cls-5{fill:#f0c087;}.cls-6{fill:#3b485e;}.cls-7{fill:#785550;}.cls-8{fill:#694b4b;}.cls-9{fill:#5a4146;}.cls-10{fill:#fbcb99;}.cls-11{fill:#edba89;}.cls-12{fill:#f5f5f7;}.cls-13{fill:#d2d2d7;}.cls-14{fill:#324a5e;}.cls-15{fill:#283d4c;}.cls-16{fill:#563b3b;}.cls-17{fill:#7f7369;}.cls-18{fill:#6d5e53;}.cls-19{fill:silver;}.cls-20{fill:#afafb2;}.cls-21{fill:#dadada;}.cls-22{fill:#dd9a5e;}.cls-23{fill:#d38d54;}.cls-24{fill:#edae6b;}.cls-25{fill:#4c4846;}.cls-26{fill:#3f3b39;}.cls-27{fill:#3d3937;}.cls-28{fill:#72655a;}.cls-29{fill:#eab883;}.cls-30{fill:#d8a373;}.cls-31{fill:#d83d3d;}.cls-32{fill:#a82626;}.cls-33{fill:#f7cf9c;}.cls-34{fill:#b72c2c;}.cls-35{fill:#70bbef;}.cls-36{fill:#4caee5;}.cls-37{fill:#ceccca;}.cls-38{fill:#ff9656;}.cls-39{clip-path:url(#clip-path);}.cls-40{fill:#ef8c56;}.cls-41{fill:#ffd7a3;}.cls-42{fill:#fdc88e;}.cls-43{fill:#9bce7a;}.cls-44{fill:#ffe1b2;}.cls-45{fill:#8abe69;}.cls-46{fill:#76ab5f;}.cls-47{clip-path:url(#clip-path-3);}.cls-48{fill:#f5b97a;}.cls-49{fill:#ff6473;}.cls-50{fill:#f05467;}.cls-51{fill:#bd445a;}.cls-52{fill:#9d6e48;}.cls-53{fill:#8d5f3d;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.21,
    y: 78.95,
    width: 27.37,
    height: 42.02
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 119.17,
    y: 74.26,
    width: 32.05,
    height: 46.72
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Maske"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 160,
    height: 160,
    rx: 8
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "56.56 67.03 56.56 62.25 44.27 62.25 44.27 67.03 50.42 72.5 56.56 67.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M66.07,69.27l-8.45-2a1.42,1.42,0,0,1-.36-.14l-6.84,4L43.84,67a1.38,1.38,0,0,1-.62.33l-8.45,2a2.73,2.73,0,0,0-2.11,2.66v20.5A1.37,1.37,0,0,0,34,93.8H66.81a1.37,1.37,0,0,0,1.37-1.37V71.93A2.74,2.74,0,0,0,66.07,69.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M44.27,62.25v5c7.74,2.79,12.3-4.2,12.3-4.2v-.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M41.54,46.54l.59,13.1a4.11,4.11,0,0,0,1.64,3.09l2.82,2.12a4.13,4.13,0,0,0,2.46.82h2.73a4.11,4.11,0,0,0,2.46-.82l2.83-2.12a4.07,4.07,0,0,0,1.63-3.09l.6-13.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M48.37,49.28c2.73,0,6.83-.69,7.8-2.74H41.54l.59,13.1a4.11,4.11,0,0,0,1.64,3.09l2.82,2.12a4.13,4.13,0,0,0,2.46.82h1.37c-1.37,0-4.1-2.73-4.1-6.15v-8.2A2.17,2.17,0,0,1,48.37,49.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M63.16,74.21l4.43-4a2.73,2.73,0,0,1,.59,1.69v20.5a1.37,1.37,0,0,1-1.37,1.37H62V91.9C62,90.94,62.44,74.86,63.16,74.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M37.67,74.21l-4.42-4a2.73,2.73,0,0,0-.59,1.69v20.5A1.37,1.37,0,0,0,34,93.8h4.78V91.9C38.81,90.94,38.4,74.86,37.67,74.21Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "52.13 93.8 48.71 93.8 49.14 72.5 51.7 72.5 52.13 93.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M52.13,71.13H48.71v.4a1.65,1.65,0,0,0,1.65,1.65h.11a1.66,1.66,0,0,0,1.66-1.65v-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M44.18,65.51l6.24,5.62a23.43,23.43,0,0,0-3.91,2.66.88.88,0,0,1-1.36-.3L42.22,67l.93-1.39A.69.69,0,0,1,44.18,65.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M56.66,65.51l-6.24,5.62a23.16,23.16,0,0,1,3.9,2.66.88.88,0,0,0,1.36-.3L58.61,67l-.92-1.39A.69.69,0,0,0,56.66,65.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M54.56,42l.64,4.52c2.92.59,3.34,5.17,3.4,6.49a1.33,1.33,0,0,0,.22.66l1.11,1.73a6.54,6.54,0,0,1,1.37-4.78S61.9,39.29,54.56,42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M60.62,55.13l-.77,3.09a.83.83,0,0,1-.8.62h0a.82.82,0,0,1-.81-.72L57.84,55a1.42,1.42,0,0,1,1.41-1.59h0A1.42,1.42,0,0,1,60.62,55.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M42.19,40.79l1,.69c-4.56,3.38-3.71,9.16-3.71,9.16,1.37,1.37,1.37,4.78,1.37,4.78l1.36-1.36s-.53-4,2.05-5.47c2.39-1.41,4.48-.68,6.62-.68,5.72,0,7.32-2.16,7-4.78-.14-1.36-2.22-4.19-7.51-4.1A23.12,23.12,0,0,0,42.19,40.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M41.8,47.31a7.5,7.5,0,0,1,1.4-5.83c-4.56,3.38-3.71,9.16-3.71,9.16,1.37,1.37,1.37,4.78,1.37,4.78l1.36-1.36s-.53-4,2.05-5.47c2.39-1.41,4.48-.68,6.62-.68a16.28,16.28,0,0,0,2.46-.17C49,47.89,46.35,44.55,41.8,47.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M40.22,55.13,41,58.22a.82.82,0,0,0,.79.62h0a.82.82,0,0,0,.82-.72L43,55a1.41,1.41,0,0,0-1.4-1.59h0A1.41,1.41,0,0,0,40.22,55.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M58.61,92.43H55.2a1.37,1.37,0,0,0-1.37,1.37H60A1.37,1.37,0,0,0,58.61,92.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M121.07,65.16a1.41,1.41,0,0,1,.14-.18,17.4,17.4,0,0,0,2.64-9.32c0-8.52-5.87-15.45-13.09-15.45S97.67,47.14,97.67,55.66a17.26,17.26,0,0,0,2.71,9.41l.05.08c.06.09.12.17.17.26a1.53,1.53,0,0,0,1.74.57l.07,0h0a19,19,0,0,1,2.86-.8l1.82-.37-1.37-1.25a6.42,6.42,0,0,1-2-3.87l-.1-.75-.76-.06a2.42,2.42,0,0,1,0-4.81l.83-.08,0-.66a18.53,18.53,0,0,0,7.12-4,13.18,13.18,0,0,0,7.17,4V54l.83.08a2.42,2.42,0,0,1,0,4.81l-.75.06-.11.75a6.37,6.37,0,0,1-2,3.87l-1.36,1.25,1.81.37a19.44,19.44,0,0,1,3,.85A1.56,1.56,0,0,0,121.07,65.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M114.28,68.12V64.69L113.1,65a6.26,6.26,0,0,1-1.62.21H110a6.39,6.39,0,0,1-1.63-.21l-1.18-.31v3.42l-3.52.84.77,2.73.31.19a12.09,12.09,0,0,0,3.53,1.39,11.79,11.79,0,0,0,2.49.27h0a11.65,11.65,0,0,0,5.91-1.66l.32-.19.75-2.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M109.45,73.26a12.09,12.09,0,0,1-3.53-1.39h0l-.75-2.76,2.88-.69v-3.3l-.82-.43v3.42l-3.52.84.77,2.73.31.19a12.09,12.09,0,0,0,3.53,1.39,11.79,11.79,0,0,0,2.49.27h.55A11.53,11.53,0,0,1,109.45,73.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M115.43,72.27a11.18,11.18,0,0,1-4.65,1,11.31,11.31,0,0,1-2.46-.27,11.67,11.67,0,0,1-2.23-.74l-1.37-.61,3.48,27.46h5.13l3.48-27.49Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "104.72 71.67 108.2 99.13 109.33 99.13 106.01 72.24 104.72 71.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M122.74,70.9a13.83,13.83,0,0,0-1.39-.68l-.22-.09a35.28,35.28,0,0,0-4.08-1.32L112.8,99.13h12a1.53,1.53,0,0,0,1.61-1.56V77.9A8,8,0,0,0,122.74,70.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M104.34,68.81a34.68,34.68,0,0,0-4.08,1.32l-.23.09a13.83,13.83,0,0,0-1.39.68,8,8,0,0,0-3.66,7V97.57a1.53,1.53,0,0,0,1.61,1.56h12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M96.54,97.57V77.9a8,8,0,0,1,3.66-7,12.85,12.85,0,0,1,1.39-.68l.22-.09c.89-.36,1.83-.68,2.64-.92l-.11-.4a34.68,34.68,0,0,0-4.08,1.32l-.23.09a13.83,13.83,0,0,0-1.39.68,8,8,0,0,0-3.66,7V97.57a1.53,1.53,0,0,0,1.56,1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M121.33,99.13V77.77a.71.71,0,0,0-.71-.71.7.7,0,0,0-.7.71V99.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M101.38,99.13V77.77a.7.7,0,0,0-.7-.71.71.71,0,0,0-.71.71V99.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M119.23,53.48a1.24,1.24,0,0,0-1.62,1.19v3.56a1.24,1.24,0,0,0,1.25,1.25,1.15,1.15,0,0,0,.37-.06,2.76,2.76,0,0,0,.7-.32,1,1,0,0,0,.34-.31,1.13,1.13,0,0,0,.37-.28,3.11,3.11,0,0,0-1.41-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M103.39,53.66a1.26,1.26,0,0,0-1.11-.18,3.11,3.11,0,0,0,0,5.94,1.15,1.15,0,0,0,.37.06,1.24,1.24,0,0,0,1.25-1.25V54.67A1.26,1.26,0,0,0,103.39,53.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M118.37,53.53V53.4a.61.61,0,0,0-.38-.55l-.34-.08a12.73,12.73,0,0,1-6.15-3.31h0a1.19,1.19,0,0,0-1.6,0h0a18.22,18.22,0,0,1-6.09,3.29l-.15,0h0a.64.64,0,0,0-.51.53v5.46A6.9,6.9,0,0,0,110,65.68h1.44a6.9,6.9,0,0,0,6.89-6.89V53.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M111.24,49.27a1.24,1.24,0,0,0-1.34.19h0a18.22,18.22,0,0,1-6.09,3.29l-.15,0h0a.64.64,0,0,0-.51.53v5.46A6.9,6.9,0,0,0,110,65.68h1.13a6.9,6.9,0,0,1-6.89-6.89V53.73a1.06,1.06,0,0,1,.71-1l.18-.06h0a17.61,17.61,0,0,0,6-3.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M100.43,65.15c.06.09.12.17.17.26a1.54,1.54,0,0,0,1.77.56l0,0-.11-.15a17.11,17.11,0,0,1-3.22-10.14c0-8.24,5.49-15,12.39-15.43-.24,0-.47,0-.71,0-7.22,0-13.09,6.93-13.09,15.45a17.26,17.26,0,0,0,2.71,9.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M104.65,96.87a6,6,0,0,0-1.28-3.35h0c-1.92-2.33-4.67-2.28-7.32-3.1l-.28-.07-2.83-1.75V85.74a9.73,9.73,0,0,1-7.84,0v2.85l-2.84,1.75-.28.07c-2.81.78-4.17.82-5.75,1.77h0a7.29,7.29,0,0,0-1.52,1.32h0c-1.68,2-1.06,2.81-3.49,23.06a5.24,5.24,0,0,0,0,.71h0A3.47,3.47,0,0,0,74.67,121h28.7a3.45,3.45,0,0,0,3.51-3.66C106.9,116.52,107,117.63,104.65,96.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M74.44,116.58c2.28-21.79,2.14-21.16,2.36-22.24A5.33,5.33,0,0,1,77.93,92h0a6.8,6.8,0,0,1,.71-.71,8.11,8.11,0,0,0-2.39.93h0a7.29,7.29,0,0,0-1.52,1.32h0c-1.68,2-1.06,2.83-3.49,23.06a6.37,6.37,0,0,0,0,.71A3.47,3.47,0,0,0,74.67,121H78C75.8,121,74.19,119.37,74.44,116.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M96.05,90.41l-.28-.07-2.83-1.75V85.74a9.81,9.81,0,0,1-7.84,0h0v2.82l-2.84,1.75-.28.07L79.64,91h0l3.16,5.22a7.28,7.28,0,0,0,12.44,0L98.45,91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M85.12,95.08l-2.86-4.74-.27.07L79.64,91h0l3.16,5.22a7.3,7.3,0,0,0,10.56,2.1A7.27,7.27,0,0,1,85.12,95.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M99.46,101.64a1,1,0,0,0-1-.92h0a1,1,0,0,0-.92,1c.11,2.15.91,17.22,1,19.21h2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M79.65,100.72h0a1,1,0,0,0-1,.92L77.6,121h2l.38-7.2.64-12A1,1,0,0,0,79.65,100.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M95.77,90.34l-3.2,5.35a.93.93,0,0,1-1.35.26L89,94.28l3.91-5.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M82.27,90.34l3.24,5.35a.93.93,0,0,0,1.35.26l2.19-1.67-3.94-5.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M85.1,85.37h0v3.21l3.94,5.69,3.89-5.69V85.35A9.8,9.8,0,0,1,85.1,85.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M89.05,86.18a9.64,9.64,0,0,1-4-.81h0v3.21l3.94,5.69h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M88.91,56.63A12.18,12.18,0,0,0,80.39,60s-6.65,1.16-4.16,12.58h25.45c2.49-11.42-4.16-12.65-4.16-12.65A12.12,12.12,0,0,0,89,56.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M80.37,60c-.42.09-6.55,1.54-4.14,12.57h3.3C77.71,65.85,78.83,62.06,80.37,60Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M76.1,73.28c0,1.42,1.48,2.57,3.17,2.57V70.72C77.58,70.72,76.1,71.87,76.1,73.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M101.89,73.28c0,1.42-1.47,2.57-3.16,2.57V70.72C100.42,70.72,101.89,71.87,101.89,73.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M76.42,72.18a2.16,2.16,0,0,0-.32,1.1c0,1.42,1.48,2.57,3.17,2.57V73.64A3.32,3.32,0,0,1,76.42,72.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M98.73,73.64v2.21c2.24,0,3.89-1.95,2.85-3.67A3.34,3.34,0,0,1,98.73,73.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M98.83,69.33h0v-.15s0-.06,0-.05a4.1,4.1,0,0,0-1.75-2.91h0l-.18-.13h0l-.2-.12h0A2.64,2.64,0,0,1,96,62.26l.2-.27v0l.08-.11,1-1.6h0l.24-.37A12.51,12.51,0,0,0,80.39,60l0,0,1.07,1.52h0l.53.76A2.63,2.63,0,0,1,81.3,66h0a4,4,0,0,0-2.14,3.36h0c0,7.78,0,7.67,0,8.33,1.08,11.62,18.62,12,19.59-.09,0-.73,0-.1,0-8.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M82.4,76.91c0-.42,0,.9,0-7.58h0A4,4,0,0,1,84.54,66h0a2.64,2.64,0,0,0,.72-3.71c-.37-.52-.28-.38-.54-.76h0l-.32-.44a1.48,1.48,0,0,1,.32-2,12.94,12.94,0,0,1,5.91-2.4,12.6,12.6,0,0,0-10.2,3.29V60l1.07,1.52h0c.18.27.23.33.53.76A2.63,2.63,0,0,1,81.3,66h0a4,4,0,0,0-2.14,3.36h0c0,7.19,0,7.54,0,8.28a9.85,9.85,0,0,0,11.42,8.81A9.82,9.82,0,0,1,82.4,76.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M96.42,79.55a7.66,7.66,0,0,1-2.65-1.61c-1.3-1.3-3.34-2.23-4.7-1.07a.07.07,0,0,1-.14,0c-1.36-1.16-3.4-.23-4.7,1.07a7.66,7.66,0,0,1-2.65,1.61.4.4,0,0,0,0,.72A6.24,6.24,0,0,0,89,79.58l0-.06,0,.06a6.24,6.24,0,0,0,7.42.69A.4.4,0,0,0,96.42,79.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M96.47,80.27h0c-4.11-.36-5.21-1-6.78-2h0a1.57,1.57,0,0,0-1.36,0c-1.57.95-2.67,1.62-6.78,2A6.24,6.24,0,0,0,89,79.58l0-.06,0,.06a6.24,6.24,0,0,0,7.42.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M135.6,116.58l-.58-5.17h0l-.45-4.07h0l-.66-5.94h0l-.32-2.83h0c-.27-2.22-.21-4.65-3-6.36h-.05c-1.66-1-2.87-1-8.49-2.45a.85.85,0,0,1-.37-.78V85.13a9,9,0,0,1-7.84,0V89a.87.87,0,0,1-.36.78c-5.59,1.48-6.83,1.45-8.5,2.45h0c-3.13,1.91-2.72,5-3,6.36h0l-.32,2.83h0l-.66,5.94h0l-.45,4.07h0c-.55,5.08-.62,5.14-.6,5.88a3.49,3.49,0,0,0,2.42,3.5h0a4.21,4.21,0,0,0,1.17.15h0c29.91,0,28.85.1,29.71-.15h0C134.7,120.36,135.8,118.94,135.6,116.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M105.62,120.8h0a3.49,3.49,0,0,1-2.42-3.5c0-.74,0-.73.6-5.88h0l.45-4.07h0l.66-7.37h0l.32-2.84h0c.27-1.48-.06-4,2.42-6a9,9,0,0,0-2.68,1h0c-3.13,1.91-2.72,5-3,6.36h0l-.32,2.83h0l-.66,5.94h0l-.45,4.07h0c-.58,5.34-.6,5-.6,5.88a3.52,3.52,0,0,0,2.42,3.5h0c1,.3,1.92.06,4.47.15A4.58,4.58,0,0,1,105.62,120.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M117.79,56.52h-.05A14.76,14.76,0,0,0,103,71.28c0,.11,0,.22,0,.33v.49c-.21,8.15,4.62,14.34,12,14.4l5.23,0c6.8.06,12.52-5.38,12.3-14.45a4,4,0,0,1,0-.49A14.76,14.76,0,0,0,117.79,56.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M113.77,84.71c-5.54-3.53-5.88-10.28-5.82-12.61v-.49c0-.11,0-.22,0-.33a14.75,14.75,0,0,1,12.3-14.55,14.22,14.22,0,0,0-2.45-.21h-.05A14.76,14.76,0,0,0,103,71.28c0,.11,0,.22,0,.33v.49c-.21,8.15,4.62,14.34,12,14.4,5.25,0,5.38.08,6.28,0A13.2,13.2,0,0,1,113.77,84.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M108.29,121l1-19.21a1,1,0,0,0-.91-1,1,1,0,0,0-1,.92l-1,19.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M128.2,101.64a1,1,0,0,0-1.94.1l1,19.21h2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M104.94,73a2.79,2.79,0,0,0,3,2.52v-5A2.79,2.79,0,0,0,104.94,73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M130.27,73a2.8,2.8,0,0,1-3,2.52v-5A2.8,2.8,0,0,1,130.27,73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M105.22,71.93a2.15,2.15,0,0,0-.28,1.06,2.79,2.79,0,0,0,3,2.52V73.38A3.1,3.1,0,0,1,105.22,71.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M127.26,73.38v2.13c2.22,0,3.65-1.93,2.73-3.58A3.11,3.11,0,0,1,127.26,73.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M125.25,90.52l-3.2-.79a.85.85,0,0,1-.37-.78V85.13a9,9,0,0,1-7.84,0V89a.85.85,0,0,1-.37.78l-3.12.77h0l2.78,3.4a6,6,0,0,0,9.36,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M117.46,86a9.69,9.69,0,0,1-3.62-.89V89a.85.85,0,0,1-.37.78l-3.12.77h0l2.78,3.4a6,6,0,0,0,4.33,2.21V86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M112.28,92.87l.85,1a6,6,0,0,0,9.36,0l.85-1Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 117.81,
    cy: 104.35,
    r: 1.17
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 117.81,
    cy: 99.99,
    r: 1.17
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 117.81,
    cy: 108.72,
    r: 1.17
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M125.84,67.93a1.54,1.54,0,0,1,1.42,1.55c0,7.15,0,7.18,0,7.76A9.66,9.66,0,0,1,117.6,86h0a9.67,9.67,0,0,1-9.66-9.66V70.69a1.29,1.29,0,0,1,1.18-1.29c2.19-.19,7-1,10.52-3.88a1.19,1.19,0,0,1,1.63.1A7.2,7.2,0,0,0,125.84,67.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M111.21,76.37c0-7.16,0-6.91.05-7.26-.84.15-1.58.24-2.14.29a1.29,1.29,0,0,0-1.18,1.29c0,6.1,0,5.94,0,6.6a9.66,9.66,0,0,0,11.25,8.6S111.21,81.25,111.21,76.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M113.13,93.91a6,6,0,0,0,7.48,1.54,4.43,4.43,0,0,1-3.15-2.58h-5.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M64.49,84.71H58.33a1.7,1.7,0,0,1-1.7-1.7l-.85-14.36s-1.37-11.9,5.75-13.47c0,0,2.89-5.63,12.16-3.82a5.1,5.1,0,0,1,.58.17C87.5,55.84,83.68,69.88,83.14,83a1.7,1.7,0,0,1-1.7,1.7H74.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M65.56,84.71v-2a10.41,10.41,0,0,1-1.51-.81c-.25-.16-.49-.33-.71-.49-5-3.81-4.08-9.31-4.18-10V67a.45.45,0,0,1,0-.11c-.07-3.38.46-10.48,5.84-11.67,0,0,1.77-3.45,7-4.08-8-.88-10.46,4.07-10.47,4.08-4.79,1-6,6.89-5.85,11.79a1.41,1.41,0,0,1,0,.2c0,.91.09,1.48.09,1.48L56.63,83a1.7,1.7,0,0,0,1.7,1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M89.16,116.14c-2.48-22-2.34-21.37-2.57-22.44a6.07,6.07,0,0,0-2.87-4l0,0c-1.81-1.08-3.12-1-9.22-2.66a.92.92,0,0,1-.39-.85V82.71a10.64,10.64,0,0,1-8.5,0v3.47a.9.9,0,0,1-.4.85c-6,1.61-7.4,1.58-9.21,2.66l-.05,0a6.23,6.23,0,0,0-3,5.07c-2.5,22.6-2.43,21.31-2.42,22.14h0a3.77,3.77,0,0,0,3.91,4H85.28C87.94,120.88,89.4,118.9,89.16,116.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M54,116.91h0a5.79,5.79,0,0,1,0-.76c2.47-23.21,2.32-22.55,2.56-23.71a6.08,6.08,0,0,1,2.81-4A11.61,11.61,0,0,0,56,89.67l-.05,0a6.23,6.23,0,0,0-3,5.07c-2.5,22.6-2.43,21.31-2.42,22.14h0a3.77,3.77,0,0,0,3.91,4h3.51A3.77,3.77,0,0,1,54,116.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M87.85,104.47c-1.14-10.15-1.08-9.91-1.26-10.77a6.06,6.06,0,0,0-2.87-4l0,0c-1.81-1.08-3.12-1-9.22-2.66a.92.92,0,0,1-.39-.85V82.71h0v0a10.56,10.56,0,0,1-8.5,0v0h0v3.45a.9.9,0,0,1-.4.85c-6,1.61-7.4,1.58-9.21,2.66l-.05,0a6.27,6.27,0,0,0-3,5.07l-1.08,9.71,6.84.71a.69.69,0,0,1,.62.72l-.75,15h22.7L80.39,106a.75.75,0,0,1,.67-.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M52.85,94.76l-1.08,9.71,3.4.35c1.21-11.22,1.14-11.26,1.37-12.39a6,6,0,0,1,2.81-4A11.94,11.94,0,0,0,56,89.67l-.05,0A6.23,6.23,0,0,0,52.85,94.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M69.78,92.15a8.79,8.79,0,0,0,7.54-4.42L74.45,87a.92.92,0,0,1-.39-.85V82.29h0v0a10.56,10.56,0,0,1-8.5,0v0h0v3.87a.9.9,0,0,1-.4.85l-2.91.73A8.79,8.79,0,0,0,69.78,92.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M69.09,88.31V83.14a10.46,10.46,0,0,1-3.53-.87v3.89a.9.9,0,0,1-.4.85l-2.91.73a9.43,9.43,0,0,0,2.86,3l3-1.11S69.09,89.16,69.09,88.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M79.43,69.43a1.11,1.11,0,0,1,1.07,1.12v.81h0a17.57,17.57,0,0,1-.16,3.39,10.67,10.67,0,0,1-16.29,7.13c-.25-.16-.49-.33-.71-.49-5-3.82-4.08-9.3-4.18-10V67.5h0V67a1.32,1.32,0,0,1,1.06-1.29,8.51,8.51,0,0,0,4.44-2.56,1,1,0,0,1,1.46,0A18,18,0,0,0,79.43,69.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M65.9,80.56l-.08-.08-.23-.23,0,0h0l0,0a2,2,0,0,1-.19-.22c-3.63-4.15-2.44-8-2.67-11.15V64.71a8.44,8.44,0,0,1-2.46,1A1.32,1.32,0,0,0,59.16,67v4.4c.1.68-.9,6.54,4.63,10.35l.39.26a10.63,10.63,0,0,0,7.41,1.47C71.49,83.42,67.42,82,65.9,80.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M79.38,88.24l-2.06-.51a8.79,8.79,0,0,1-7.54,4.42S79.42,101.79,79.38,88.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M60.24,88.24l2-.51a8.81,8.81,0,0,0,7.54,4.42S60.19,101.79,60.24,88.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M65.25,90.8c-1.7.91-3.66,1.34-4.92-.34,1,10.19,9.5,1.69,9.5,1.69A8.42,8.42,0,0,1,65.25,90.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M74.37,90.8c1.7.91,3.66,1.34,4.91-.34-1,10.19-9.5,1.69-9.5,1.69A8.46,8.46,0,0,0,74.37,90.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M51.53,117a6.2,6.2,0,0,1,0-.77c.14-1.23,1.88-16.77,2-17.72.48-3.39.2-5.39,1.8-7.33a7.22,7.22,0,0,0-1.65-1.44h0c-1.72-1-3.17-1.07-6.36-2h0L44,86.2h0V82.3a10.69,10.69,0,0,1-8.52,0h0v3.89h0l-3.26,1.55h0c-3.17.87-4.63.92-6.35,2h-.05a6.25,6.25,0,0,0-3,5.08c-.12,1-.92,8.22-1.09,9.72h0C20.31,117,20.35,116,20.35,117a3.77,3.77,0,0,0,3.91,4H55.34A3.75,3.75,0,0,1,51.53,117Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M23.87,117c0-.83,0-.37,1.34-12.46,1.17-11.81.86-12.93,2.47-14.9a6,6,0,0,1,1-1,9.28,9.28,0,0,0-2.82,1.07h-.05a6.24,6.24,0,0,0-3,5.08c-.12,1-.92,8.2-1.09,9.72-1.34,12.13-1.35,11.63-1.34,12.46a3.76,3.76,0,0,0,3.91,4h3.52A3.77,3.77,0,0,1,23.87,117Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M39,89.55V83.17a10.48,10.48,0,0,1-3.51-.84v3.89h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M53.67,89.73h-.06c-1.72-1-3.19-1.08-6.33-2h0L44,86.2l0,0h0l-4.26,4-4.24-4-3.26,1.55h0c-3.17.87-4.63.92-6.35,2h-.05a6.24,6.24,0,0,0-3,5.08l-1.09,9.72,6.73.71a.8.8,0,0,1,.71.84L28.39,121H51.12L50.33,106a.75.75,0,0,1,.67-.78l1.8-.19.74-6.56c.48-3.42.2-5.37,1.79-7.32A7.43,7.43,0,0,0,53.67,89.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M25.21,104.53c1.17-11.81.86-12.93,2.47-14.9a6,6,0,0,1,1-1,9.19,9.19,0,0,0-2.82,1.07h-.05c-3.72,2.27-2.8,5-4.14,14.8l3.48.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0",
    "data-name": "SVGCleanerId 0",
    className: "cls-25",
    d: "M26.39,68c0-3.17-1.09-12.44,8.58-16.14a13.36,13.36,0,0,1,15,3.89h0c4.16,5,2.88,10.11,3.12,12.25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0-2",
    "data-name": "SVGCleanerId 0",
    className: "cls-25",
    d: "M26.39,68c0-3.17-1.09-12.44,8.58-16.14a13.36,13.36,0,0,1,15,3.89h0c4.16,5,2.88,10.11,3.12,12.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M29.3,61.75a13.35,13.35,0,0,1,11.76-10.7,13.32,13.32,0,0,0-8.6,2.09c-6.3,4.09-6,9.59-6.07,14.86h2.66C29.07,64.39,29,63.53,29.3,61.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M53.74,69.2A3.09,3.09,0,0,1,50.42,72V66.41A3.09,3.09,0,0,1,53.74,69.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M25.72,69.2A3.09,3.09,0,0,0,29.05,72V66.41A3.1,3.1,0,0,0,25.72,69.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M50.42,69.48V72c2.49,0,4.07-2.2,3-4A3.44,3.44,0,0,1,50.42,69.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M26.08,68a2.37,2.37,0,0,0-.36,1.25A3.09,3.09,0,0,0,29.05,72v-2.5A3.42,3.42,0,0,1,26.08,68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M48,62.48A1.52,1.52,0,0,0,46.19,61l-.26,0a41,41,0,0,1-12.66,0,1.53,1.53,0,0,0-1.76,1.46,5.46,5.46,0,0,1-.19,1.32,4.25,4.25,0,0,1-1.27,2,3.64,3.64,0,0,1-1,.62v6.48a10.68,10.68,0,0,0,21.08,2.47c.39-1.65.29-2.32.29-9A4.23,4.23,0,0,1,48,62.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M32.6,75.34c-.13-1.06-.08-1.27-.09-7.6A1.51,1.51,0,0,1,33,66.58a4.52,4.52,0,0,0,.7-.6,4.71,4.71,0,0,0,.64-.92l.11-.21c.83-1.81.08-2.73,1.11-3.53-.8-.08-1.58-.18-2.33-.3a1.53,1.53,0,0,0-1.76,1.46,5.4,5.4,0,0,1-.19,1.32,4.27,4.27,0,0,1-1.27,2,3.64,3.64,0,0,1-1,.62v6.48a10.79,10.79,0,0,0,2.87,7.28,10.55,10.55,0,0,0,5.19,3.07S33,78.43,32.6,75.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M40.79,97.91V89.24l-1.06,1-1-1v8.67a1.06,1.06,0,1,0,2.11,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M44,86.2l-4.29,4L42,92.57a1,1,0,0,0,1.56-.1l3.68-4.7Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "45.66 86.99 44.02 86.2 39.73 90.24 41.26 91.78 45.66 86.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M42.36,92.78a1.07,1.07,0,0,0,.61.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M35.49,86.22l4.24,4-2.31,2.33a1,1,0,0,1-1.56-.1l-3.68-4.7Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "36.74 90.22 38.2 91.78 39.73 90.24 35.49 86.22 33.74 87.03 36.74 90.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M20.92,79h0C14,79,7.21,84.27,7.21,91.3c0,9.31,5.05,13.7,5.05,13.7a17.24,17.24,0,0,0-1.35,4.06h3.78a23.15,23.15,0,0,1-.27-4.06s19.47-3.55,19.47-13.7c0-6.92-6.05-12.26-13-12.26Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-39"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M27,80.47a13.57,13.57,0,0,0-6-1.43h0C14,79,7.21,84.27,7.21,91.3c0,9.31,5.05,13.7,5.05,13.7a17.24,17.24,0,0,0-1.35,4.06h3.78a23.15,23.15,0,0,1-.27-4.06,48.18,48.18,0,0,0,4.85-1.23L9.38,94S23.7,89,27,80.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M34.56,116.36l-.14-.48a.46.46,0,0,0-.51-.33l-.48-3.61a3.72,3.72,0,0,0-2.1-2.82l-1.42-.71c-.23-.11-.41,0-.57.22l-3.11-1.14a1.45,1.45,0,0,1-1-1.37V103.8l3.11-1.3a4.32,4.32,0,0,0,2.66-4v-.72a2.17,2.17,0,0,0,0-4.33V92c0-2-1.61-5-3.61-5h-13c-2,0-3.6,3.06-3.6,5v1.44a2.17,2.17,0,0,0,0,4.33v.72a4.32,4.32,0,0,0,2.66,4l3.11,1.3v2.32a1.45,1.45,0,0,1-1,1.37l-3.11,1.14c-.16-.18-.34-.33-.57-.22l-1.42.71a3.72,3.72,0,0,0-2.1,2.82l-.48,3.61a.46.46,0,0,0-.51.33l-.14.48a.48.48,0,0,0,.32.59l1.07.31v2.16a1.43,1.43,0,0,0,1.44,1.44H31.73a1.43,1.43,0,0,0,1.44-1.44v-2.16l1.07-.31a.48.48,0,0,0,.32-.59Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M25.24,103.72l-8.65,0v2.38a1.44,1.44,0,0,1-.7,1.24,9.79,9.79,0,0,0,9.35-3.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M33.43,111.94a3.72,3.72,0,0,0-2.1-2.82l-1.42-.71c-.26-.13-.45.08-.64.31a25.84,25.84,0,0,1-8.35,6.38,25.81,25.81,0,0,1-8.36-6.38c-.19-.23-.38-.44-.64-.31l-1.42.71a3.72,3.72,0,0,0-2.1,2.82l-.58,4.4C9.72,117,13,118,13,118v2.88H28.85V118s3.26-1,5.16-1.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M31,93.46V92c0-2-1.61-5-3.61-5h-13c-2,0-3.6,3.06-3.6,5v1.44a2.17,2.17,0,0,0,0,4.33v.72a4.32,4.32,0,0,0,2.66,4l4.66,1.94a7.16,7.16,0,0,0,5.55,0l4.66-1.94a4.32,4.32,0,0,0,2.66-4v-.72a2.17,2.17,0,0,0,0-4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M10.82,93.46a2.17,2.17,0,0,0,0,4.33v.72a4.32,4.32,0,0,0,2.66,4l4.66,1.94a5.83,5.83,0,0,0,.7.25A30.3,30.3,0,0,1,14.6,101a3.4,3.4,0,0,1-.9-2.31V94.9s12-1.5,15.15-6.49a3.3,3.3,0,0,0,.38-.79c-7,4-18.41,5.84-18.41,5.84Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-39"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M13,117.76a4.34,4.34,0,0,0-.84-2.38l-3.39-4.51a3.6,3.6,0,0,0-.33,1.07l-.57,4.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M7.27,116.36a.48.48,0,0,0,.32.59L13,118.52V118a4.15,4.15,0,0,0-.13-1L8,115.56a.47.47,0,0,0-.59.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M28.87,117.76a4.34,4.34,0,0,1,.84-2.38l3.39-4.51a3.6,3.6,0,0,1,.33,1.07l.57,4.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M34.56,116.36a.48.48,0,0,1-.32.59l-5.39,1.57V118a4.15,4.15,0,0,1,.13-1l4.85-1.42a.47.47,0,0,1,.59.32Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M14.42,105.72H12.26a.72.72,0,0,1,0-1.44h2.16a.72.72,0,1,1,0,1.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M9.38,86.7V94c11.25-1.34,16.59-3.72,19-5.33a29.3,29.3,0,0,1-1.1,10.55s4.32-6,3.65-12.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M9.38,86.7V94A45.55,45.55,0,0,0,22.26,86.7Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-47"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M151.21,116.73l-.07-.65a.48.48,0,0,0-.52-.42h-.05l-.7-5.63a3.21,3.21,0,0,0-2.17-2.64l-3.91-1.31a1.6,1.6,0,0,0-1.54.29L141.1,106a1.61,1.61,0,0,1-1.1-1.53v-2.58l3.45-1.44a4.8,4.8,0,0,0,3-4.44v-.8a2.41,2.41,0,0,0,1.9-3.89,20.44,20.44,0,0,0,.51-13s-.29-.21-.82-.52a5.34,5.34,0,0,0-.79-2.68l-2.92,1a31.46,31.46,0,0,0-10.7-1.77,3.42,3.42,0,0,1-1.61.8,43.92,43.92,0,0,0-5.61-.8l-1.6,4s-4,0-4,4.81a54.18,54.18,0,0,0,1.41,8,2.41,2.41,0,0,0,1.8,4V96a4.8,4.8,0,0,0,3,4.44l3.45,1.44v2.58a1.61,1.61,0,0,1-1.1,1.53l-1.15.38a1.6,1.6,0,0,0-1.54-.29l-3.91,1.31a3.21,3.21,0,0,0-2.17,2.64l-.7,5.63h0a.48.48,0,0,0-.52.42l-.07.65a.47.47,0,0,0,.42.52l1.17.13v1.87a1.6,1.6,0,0,0,1.6,1.6H148a1.6,1.6,0,0,0,1.6-1.6v-1.87l1.17-.13a.47.47,0,0,0,.42-.52Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M140,101.81h-9.62v2.65a1.59,1.59,0,0,1-.8,1.37,10.88,10.88,0,0,0,10.42-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M146.41,90.39v-1.6a4,4,0,0,0-4-4H128a4,4,0,0,0-4,4v1.6a2.41,2.41,0,1,0,0,4.81V96a4.8,4.8,0,0,0,3,4.44l5.18,2.16a8.08,8.08,0,0,0,6.16,0l5.18-2.16a4.8,4.8,0,0,0,3-4.44v-.8a2.41,2.41,0,1,0,0-4.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M144,120.85v-4h6.71l-.85-6.81a3.21,3.21,0,0,0-2.17-2.64l-3.91-1.31a1.58,1.58,0,0,0-1.83.62,8,8,0,0,1-13.54,0,1.58,1.58,0,0,0-1.83-.62l-3.91,1.31a3.21,3.21,0,0,0-2.17,2.64l-.76,6.1h6.62v4.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M128.18,98.78a3.78,3.78,0,0,1-1-2.57V89.14c2.22-1.2,8.68-4.36,15.24-4.36H128a3.59,3.59,0,0,0-.81.09h0a4,4,0,0,0-3.2,3.93v1.6a2.41,2.41,0,1,0,0,4.81V96a4.8,4.8,0,0,0,3,4.44l5.18,2.16a7,7,0,0,0,.77.27,32.69,32.69,0,0,1-4.7-4.09Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-47"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M126.37,117.45v-1.82a3.25,3.25,0,0,0-.78-2.1l-4.41-5.09a3.15,3.15,0,0,0-.67,1.59l-.84,6.7c1.28.08,4.67.47,6.7.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M126.37,116.39l-6.61-.73a.48.48,0,0,0-.52.42l-.07.65a.47.47,0,0,0,.42.52l6.78.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M144,117.45v-1.82a3.25,3.25,0,0,1,.78-2.1l4.41-5.09a3.15,3.15,0,0,1,.67,1.59l.84,6.7c-1.28.08-4.67.47-6.7.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M144,116.39l6.61-.73a.48.48,0,0,1,.52.42l.07.65a.47.47,0,0,1-.42.52L144,118Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M148.82,78.36s-.29-.21-.82-.52a5.34,5.34,0,0,0-.79-2.68l-2.92,1a31.46,31.46,0,0,0-10.7-1.77,3.42,3.42,0,0,1-1.61.8,43.92,43.92,0,0,0-5.61-.8l-1.6,4s-4,0-4,4.81a52.86,52.86,0,0,0,1.42,8,2.39,2.39,0,0,1,1.79-.81v-1.6a4,4,0,0,1,4-4,8.93,8.93,0,0,0-.75,2.4,14.16,14.16,0,0,1,8-2.4h7.22a4,4,0,0,1,4,4v1.6a2.39,2.39,0,0,1,1.9.94,20.57,20.57,0,0,0,.51-13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M147.21,75.16l-2.92,1a31.46,31.46,0,0,0-10.7-1.77,3.42,3.42,0,0,1-1.61.8,43.92,43.92,0,0,0-5.61-.8l-1.6,4s-4,0-4,4.81a52.86,52.86,0,0,0,1.42,8,2.39,2.39,0,0,1,1.79-.81v-1.6a4,4,0,0,1,3.65-4,7.29,7.29,0,0,0-.45,2.37c3.16-4,7.64-5.45,11.23-6.41s4-2.41,4-2.41,3.5-.2,4.8-3.2Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEaGemeinschaft);
export default __webpack_public_path__ + "static/media/ea_gemeinschaft.3782bbde30a39ea5251b1e4c23ca6be9.svg";
export { ForwardRef as ReactComponent };